export type Companions = {
  audioId: number | null
  audioPlaylistId: number | null
  stopScreenId: number | null
  transition: string | null
}

export const EMPTY_COMPANIONS: Companions = {
  audioId: null, audioPlaylistId: null, stopScreenId: null, transition: null,
}

export type CompanionFields = {
  companion_audio_id?: number | null
  companion_audio_playlist_id?: number | null
  companion_stop_screen_id?: number | null
  companion_transition?: string | null
}

export function companionsToPayload(c: Companions): CompanionFields {
  return {
    companion_audio_id: c.audioId,
    companion_audio_playlist_id: c.audioPlaylistId,
    companion_stop_screen_id: c.stopScreenId,
    companion_transition: c.transition,
  }
}

export function companionsFromEntity(e?: CompanionFields | null): Companions {
  return {
    audioId: e?.companion_audio_id ?? null,
    audioPlaylistId: e?.companion_audio_playlist_id ?? null,
    stopScreenId: e?.companion_stop_screen_id ?? null,
    transition: e?.companion_transition ?? null,
  }
}

export function hasCompanions(c: Companions): boolean {
  return c.audioId != null || c.audioPlaylistId != null
    || c.stopScreenId != null || c.transition != null
}
